import { useCallback } from 'react';

import { CredentialType, SubscriptionInputDto, SubscriptionOutputDto } from '@api/ecommerce-xp';
import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { UseFetchServiceSuccessResult } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetchSubscription } from '@services';
import { useUserInput } from '@store';
import { IntegratorEnum } from '@types';

interface SubscriptionMaintenanceInput {
	token: string;
}
interface SubscriptionMaintenanceOutput {
	subscription: () => Promise<UseFetchServiceSuccessResult<SubscriptionOutputDto>>;
}

export const useSubscription = (props: SubscriptionMaintenanceInput): SubscriptionMaintenanceOutput => {
	const { token } = props;
	const { fetch: fetchSubscription } = useFetchSubscription();
	const t = useTranslation();
	const { acceptedTermsAndConditionsBank, selectedIntegrator, selectedAccount, forms, acceptMasterOrVisaCards } =
		useUserInput();

	const getMergedString = useCallback((text1: string | undefined, text2: string | undefined) => {
		let togetherString = '';
		if (!CoreHelper.isNullOrEmpty(text1)) {
			togetherString = text1 as string;
		}
		if (!CoreHelper.isNullOrEmpty(text2)) {
			togetherString += text2 as string;
		}
		return togetherString;
	}, []);

	const subscription = () => {
		const phoneCorporate = getMergedString(
			forms?.corporateData?.corporateInfo?.indicative,
			forms?.corporateData?.corporateInfo?.phone
		);
		const phoneResponsible = getMergedString(
			forms?.corporateData?.responsibleInfo?.indicative,
			forms?.corporateData?.responsibleInfo?.phone
		);
		const phoneIntegrator = getMergedString(
			forms?.integratorData?.info?.indicative,
			forms?.integratorData?.info?.phone
		);

		let nameIntegration = selectedIntegrator?.name;
		let codeIntegration = undefined;
		if (
			selectedIntegrator?.code !== IntegratorEnum.Other &&
			selectedIntegrator?.code !== IntegratorEnum.AddNewIntegrator
		) {
			codeIntegration = selectedIntegrator?.code;
		}

		if (selectedIntegrator?.code === IntegratorEnum.Other) {
			nameIntegration = forms?.integratorData?.corporateName;
		} else if (selectedIntegrator?.code === IntegratorEnum.AddNewIntegrator) {
			nameIntegration = selectedAccount?.companyName;
		}
		const data: SubscriptionInputDto = {
			credentialType: CredentialType.Sms,
			credentialCode: token,
			nif: selectedAccount?.companyNif,
			cards: acceptMasterOrVisaCards ? 'S' : 'N',
			accountId: selectedAccount?.account.id,
			companyName: selectedAccount?.companyName,
			//Form corporateData
			onlineStore: forms?.corporateData?.storeName,
			website: forms?.corporateData?.website,
			email: forms?.corporateData?.corporateInfo?.email,
			contact: `+${phoneCorporate}`,
			usernameOwner: forms?.corporateData?.responsibleInfo?.name,
			userEmailOwner: forms?.corporateData?.responsibleInfo?.email,
			contactOwner: `+${phoneResponsible}`,
			//Form Integration
			companyNameIntegration: nameIntegration,
			certificationCode: codeIntegration,
			nameTech: forms?.integratorData?.info?.name,
			contactTech: forms?.integratorData?.info?.indicative !== undefined ? `+${phoneIntegrator}` : undefined,
			emailTech: forms?.integratorData?.info?.email,
			acceptGeneralTermsConditions: acceptedTermsAndConditionsBank,
			documentsTermsSubscriptionTitle: t('placeholders.millenniumDocument.terms.title'),
		};
		return fetchSubscription(data);
	};

	return { subscription };
};
